import React, { useState } from 'react';

const FAQSection: React.FC = () => {
  const [openQuestion, setOpenQuestion] = useState<number | null>(null);

  const faqs = [
    {
      question: "Are the leases designed for California law?",
      answer: "Our templates cover many common California disclosures and rules and are updated regularly. City requirements can vary."
    },
    {
      question: "How long does it take to create a lease?",
      answer: "Most landlords complete a comprehensive lease agreement in under 5 minutes. Our guided step-by-step process makes it easy to input all necessary information without missing important details."
    },
    {
      question: "Can I customize the lease terms?",
      answer: "Absolutely! While we provide California-focused defaults, you can customize rent amounts, lease duration, pet policies, utilities, and many other terms to match your specific property and requirements."
    },
    {
      question: "What if I manage multiple properties?",
      answer: "TenantTerms is perfect for multi-property landlords. You can save property templates, duplicate leases for similar units, and manage all your lease agreements from one dashboard."
    },
    // {
    //   question: "How much does it cost?",
    //   answer: "Plans start at just $1 per lease with no monthly fees. We also offer subscription plans for high-volume landlords that include additional features and priority support."
    // },
    {
      question: "Can I make changes after generating the lease?",
      answer: "Yes, you can edit and regenerate leases as many times as needed before finalizing. Once both parties sign, we recommend creating an amendment for any changes."
    },
    {
      question: "Is my data secure?",
      answer: "Security is our top priority. We use bank-level encryption, secure cloud storage, and never share your data with third parties. All information is stored in compliance with privacy regulations."
    }
  ];

  return (
    <div className="faq-section" style={{
      background: '#ffffff',
      padding: '120px 0',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '0 24px'
      }}>
        {/* Section Header */}
        <div className="faq-header" style={{
          textAlign: 'center',
          marginBottom: '80px'
        }}>
          <h2 className="faq-title" style={{
            fontSize: 'clamp(2.5rem, 4vw, 3.5rem)',
            fontWeight: 700,
            color: '#0A0B0D',
            marginBottom: '24px',
            letterSpacing: '-0.02em'
          }}>
            Frequently asked&nbsp; 
            <span style={{ color: '#0052FF' }}>questions</span>
          </h2>
          <p className="faq-subtitle" style={{
            fontSize: '1.25rem',
            color: '#5B616E',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: 1.6
          }}>
            Get answers to common questions about creating lease agreements with TenantTerms.
          </p>
        </div>

        {/* FAQ Items */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          {faqs.map((faq, index) => (
            <div 
              key={index}
              style={{
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                overflow: 'hidden',
                transition: 'all 0.2s ease'
              }}
            >
              <button
                className="faq-question"
                onClick={() => setOpenQuestion(openQuestion === index ? null : index)}
                style={{
                  width: '100%',
                  padding: '24px',
                  background: 'white',
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: '1.125rem',
                  fontWeight: 600,
                  color: '#0A0B0D',
                  transition: 'background 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#F8F9FF';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                }}
              >
                <span>{faq.question}</span>
                <span style={{
                  fontSize: '1.5rem',
                  color: '#0052FF',
                  transform: openQuestion === index ? 'rotate(45deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease'
                }}>
                  +
                </span>
              </button>
              
              {openQuestion === index && (
                <div className="faq-answer" style={{
                  padding: '0 24px 24px',
                  background: 'white',
                  borderTop: '1px solid #F3F4F6'
                }}>
                  <p style={{
                    margin: 0,
                    fontSize: '1rem',
                    lineHeight: 1.6,
                    color: '#5B616E'
                  }}>
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Support CTA removed per design request */}
      </div>

      <style>{`
        @media (max-width: 768px) {
          .faq-section {
            padding: 80px 0 !important;
          }
          
          .faq-header {
            margin-bottom: 60px !important;
          }
          
          .faq-title {
            font-size: 2.5rem !important;
          }
          
          .faq-subtitle {
            font-size: 1.125rem !important;
          }
          
          .faq-question {
            font-size: 1rem !important;
            padding: 20px !important;
          }
          
          .faq-answer {
            padding: 0 20px 20px !important;
            font-size: 0.95rem !important;
          }
          
        }

        @media (max-width: 480px) {
          .faq-section {
            padding: 60px 0 !important;
          }
          
          .faq-title {
            font-size: 2rem !important;
          }
          
          .faq-subtitle {
            font-size: 1rem !important;
          }
          
          .faq-question {
            font-size: 0.95rem !important;
            padding: 16px !important;
          }
          
          .faq-answer {
            padding: 0 16px 16px !important;
            font-size: 0.9rem !important;
          }
          
        }
      `}</style>
    </div>
  );
};

export default FAQSection;
